export default __webpack_public_path__ + "static/machine1-b1fcdb055d813138d8572064a89d0460.png";